const OthersInfoConfirm = ({fields, viewMode, member, isTransfer}) => {

  return (
    <>
              <h3>その他入力欄</h3>
              <dl>
                <dt>略歴</dt>
          <dd>{(viewMode ? member.biography : fields.biography) ? (viewMode ? member.biography : fields.biography) : ''}&nbsp;</dd>
                <dt>スポーツ現場に関わる活動</dt>
          <dd>{(viewMode ? member.activitiesForTheField : fields.activitiesForTheField) ? (viewMode ? member.activitiesForTheField : fields.activitiesForTheField) :  ''}&nbsp;</dd>
                <dt>原著論文・学会発表歴</dt>
          <dd>{(viewMode ? member.papersAndPerformanceHistory : fields.papersAndPerformanceHistory) ? (viewMode ? member.papersAndPerformanceHistory : fields.papersAndPerformanceHistory) : ''}&nbsp;</dd>
          <dt style={ isTransfer ? {'display': 'none'} : {} }>入会希望の動機と抱負</dt>
          <dd style={ isTransfer ? {'display': 'none'} : {} }>{(viewMode ? member.motivationsAndAspirations : fields.motivationsAndAspirations) ? (viewMode ? member.motivationsAndAspirations : fields.motivationsAndAspirations) : ''}&nbsp;</dd>
                </dl>
    </>
  );
}

export default OthersInfoConfirm;
